"use strict"

function getApiBaseUrl() {
    let apiBaseUrl = process.env.API_V2_EXTERNAL_URL;
    if (!/^https?:\/\//i.test(apiBaseUrl)) {
        apiBaseUrl = 'https://' + apiBaseUrl;
    }
    return apiBaseUrl;
}

export async function requestGallery(id) {
    const data = await $.get(getApiBaseUrl() + '/api/v2/groups/' + id + '/gallery')
    return data.code === 200
        ? data.data
        : {}
}

export function requestValidateCoupon(coupon) {
    if (window.user.isGuest) {
        return false;
    }
    return $.ajax({
        headers: {
            authorization: `Bearer ${window.user.token}`,
            "Content-Type": "application/json",
        },
        url: getApiBaseUrl() + '/api/v2/coupons/validate',
        data: JSON.stringify({
            organizationId: window.community.organization_id,
            communityId: window.community.id,
            resourceId: window.gid,
            couponCode: coupon,
        }),
        type: "POST",
    })
}

export async function requestStopNotifications(id, type) {
    const result = await $.ajax({
        url: getApiBaseUrl() + '/api/v2/members/notifications/stop?platform=' + type,
        type: 'put',
        headers: {
            "Content-Type": "application/json"
        },
        data: JSON.stringify({payload: id})
    })
    return result.code === 200;
}

// allow list request to wait until set request is done
let flagBookmarkInProgress = true

export async function requestSetBookmark(gid, value) {
    if (window.user.isGuest) {
        return false;
    }
    let resolve
    flagBookmarkInProgress = new Promise(r => resolve = r)
    const result = await $.ajax({
        url: getApiBaseUrl() + '/api/v2/users/bookmarks/resources/' + gid,
        type: 'put',
        headers: {
            authorization: `Bearer ${window.user.token}`,
            "Content-Type": "application/json",
        },
        data: JSON.stringify({ communityId: cid,  action: value ? 'bookmark' : 'unbookmark' })
    })
    resolve()
    return result.code === 200;
}

export async function requestListBookmarks() {
    if (window.user.isGuest) {
        return [];
    }
    await Promise.resolve(flagBookmarkInProgress)
    const result = await $.ajax({
        url: getApiBaseUrl() + '/api/v2/users/bookmarks',
        type: 'get',
        headers: {
            authorization: `Bearer ${window.user.token}`,
            "Content-Type": "application/json",
        },
        data: { communityId: cid}
    })
    return result.code === 200
        ? result.data.map(i => i.resourceId)
        : []
}

export async function sendEventInteraction(action) {
    const result = await $.ajax({
        url: getApiBaseUrl() + `/api/v2/organizations/${window.community.organization_id}/stats/interaction/hub`,
        type: 'put',
        headers: {
            // authorization: `Bearer ${window.user.token}`,
            "Content-Type": "application/json",
        },
        data: JSON.stringify({
            currentUrl: window.location.href,
            action: action,
            communityId: window.cid,
            eventId: window.gid || null,
        })
    })
    return result.code === 200;
}
